import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';


const swiper = new Swiper('.gallery-slider', {
    direction: 'horizontal',
    loop: true,

    pagination: {
        el: '.gallery-pagination',
    },
    slidesPerView: 1,
    spaceBetween: 0,

});